import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog",
    "raria-hidden": "true"
};
const _hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = { class: "modal-header" };
const _hoisted_5 = {
    class: "modal-title",
    id: "confirmeModalLongTitle"
};
const _hoisted_6 = { class: "modal-body" };
const _hoisted_7 = { class: "modal-footer" };
const _hoisted_8 = ["disabled"];
import Multiselect from 'vue-multiselect';
import { closeModal } from 'jenesius-vue-modal';
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectModal',
    props: {
        modalTitle: { type: String, },
        selectOptions: { type: Array }
    },
    emits: ['return'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const selected = ref(null);
        const hideModal = () => {
            closeModal();
        };
        const handleModal = () => {
            emit('return', selected.value);
            closeModal();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("h5", _hoisted_5, _toDisplayString(props.modalTitle), 1)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(Multiselect), {
                                searchable: false,
                                "show-labels": false,
                                "allow-empty": false,
                                modelValue: selected.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selected).value = $event)),
                                options: __props.selectOptions,
                                hideSelected: true,
                                "track-by": "id",
                                label: "name"
                            }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary",
                                disabled: props.selectOptions.length === 0,
                                onClick: handleModal
                            }, "Conferma", 8, _hoisted_8),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: hideModal
                            }, "Annulla")
                        ])
                    ])
                ])
            ]));
        };
    }
});
